import { SyncStorage } from './local-storage-helpers';

export class LimitStorage extends SyncStorage {
	
	public static LIMIT_UNAUTH_TRANSLATIONS = 10;
	public static LIMIT_UNAUTH_AI = 10;

	private static LS_KEY_TRANSLATIONS = 'unauth_translations';
	private static LS_KEY_AI = 'unauth_ai';

	public static getLimitTranslationsReached(): boolean {
		return Number(window.localStorage.getItem(this.LS_KEY_TRANSLATIONS)) >= this.LIMIT_UNAUTH_TRANSLATIONS;
	}

	public static getLimitAIReached(): boolean {
		return Number(window.localStorage.getItem(this.LS_KEY_AI)) >= this.LIMIT_UNAUTH_AI;
	}

	public static incLimitTranslations() {
		let limit = Number(window.localStorage.getItem(this.LS_KEY_TRANSLATIONS));
		return window.localStorage.setItem(this.LS_KEY_TRANSLATIONS, String(++limit));
	}

	public static incLimitAI() {
		let limit = Number(window.localStorage.getItem(this.LS_KEY_AI));
		return window.localStorage.setItem(this.LS_KEY_AI, String(++limit));
	}

}
